import network from "network/network";
import actionTypes from "./actionTypes";



export function selectChatList(user, showLoading = true) {

    return (dispatch, getState) => {

        // var defaultList = getState().chatReducer.chatList;
        // if (defaultList && defaultList.length>0) {
        //     return;
        // }
        if (showLoading) {
            dispatch({
                type: actionTypes.SELECT_CHAT_LIST_LOADING,
                isLoading: true
            })
        }



        network.get("/Messages/selectFirmMessageMaster", null, false).then((result) => {
            if (showLoading) {
                dispatch({
                    type: actionTypes.SELECT_CHAT_LIST_LOADING,
                    isLoading: false
                })
            }

            const { data } = result;

            console.log("RESULT",result)
            if (result.isSuccess && data.isSuccess) {
                var messages = (data.data);
                dispatch({
                    type: actionTypes.SELECT_CHAT_LIST_SUCCESS,
                    payload: messages
                })
            } else {
                dispatch({
                    type: actionTypes.SELECT_CHAT_LIST_ERROR,
                    errorMessage: result.errorMessage,
                    hasError: true
                })
            }

        });
    }
};



export function resetUnreadCount(number) {

    return (dispatch, getState) => {


        dispatch({
            type: actionTypes.RESET_UNREAD_COUNT,
            customerNumber: number
        })
    }
};

export function selectChatDetailList(user, showLoading = true) {

    return (dispatch, getState) => {

        if (showLoading) {
            dispatch({
                type: actionTypes.SELECT_CHAT_DETAIL_LIST_LOADING,
                isLoading: true
            })
        }

        console.log("USER ",user);
        network.get("/messages/selectMessageDetail", user, false).then((result) => {

            if (showLoading) {
                dispatch({
                    type: actionTypes.SELECT_CHAT_DETAIL_LIST_LOADING,
                    isLoading: false
                })
            }
            const { data } = result;
            if (result.isSuccess && data.isSuccess) {

                var messageMaster = (data.data);

                dispatch({
                    type: actionTypes.SELECT_CHAT_DETAIL_LIST_SUCCESS,
                    payload: messageMaster.messageList,
                    customerName: messageMaster.customerName,
                    customerId: messageMaster.customerId,
                    customerImage: messageMaster.customerImage,
                    customerNumber: messageMaster.customerNumber,
                    isAdminTransaction: messageMaster.isAdminTransaction,
                    productName:messageMaster.productName,
                    activityName:messageMaster.activityName,
                    activityId:messageMaster.activityId,
                    isOpenTransaction:messageMaster.isOpenTransaction,
                    isOpenAdmin:messageMaster.isOpenAdmin
                })

                console.log("DETAAILL",messageMaster)

            } else {
                dispatch({
                    type: actionTypes.SELECT_CHAT_DETAIL_LIST_ERROR,
                    errorMessage: result.errorMessage,
                    hasError: true
                })
            }

        });
    }
};



export function finishAdminChat(params) {

    return (dispatch, getState) => {

        dispatch({
            type: actionTypes.FINISH_ADMIN_CHAT,
        })

        network.get("/messages/finishAdminChat", params, false).then((result) => {



        });
    }
};

export function startAdminChat() {

    return (dispatch, getState) => {

        dispatch({
            type: actionTypes.START_ADMIN_CHAT,
        })
    }
}

export function startManualChat(params) {
    return (dispatch, getState) => {
        dispatch({
            type: actionTypes.START_MANUAL_CHAT_LOADING,
            isLoading: true
        })

        console.log("Manuel sohbet başlatma parametreleri:", params);
        return network.post("/Messages/startAdminChat", params, false).then((result) => {
            dispatch({
                type: actionTypes.START_MANUAL_CHAT_LOADING,
                isLoading: false
            })

            const { data } = result;
            if (result.isSuccess && data.isSuccess) {
                dispatch({
                    type: actionTypes.START_MANUAL_CHAT_SUCCESS,
                    customerNumber: params.customerNumber
                })
                
                // Refresh chat list to show updated status
                dispatch(selectChatList({}));
                
                return { success: true };
            } else {
                dispatch({
                    type: actionTypes.START_MANUAL_CHAT_ERROR,
                    errorMessage: result.errorMessage || data.errorMessage,
                    hasError: true
                })
                return { success: false, error: result.errorMessage || data.errorMessage };
            }

        }).catch((error) => {
            dispatch({
                type: actionTypes.START_MANUAL_CHAT_LOADING,
                isLoading: false
            })
            dispatch({
                type: actionTypes.START_MANUAL_CHAT_ERROR,
                errorMessage: "Manuel sohbet başlatılırken hata oluştu",
                hasError: true
            })
            return { success: false, error: "Manuel sohbet başlatılırken hata oluştu" };
        });
    }
};

export function selectChatFilterOptions() {

    return (dispatch, getState) => {

        dispatch({
            type: actionTypes.SELECT_CHAT_FILTER_OPTIONS_LOADING,
            isLoading: true
        })

        network.get("/admin/Activity/getAllActivities2", null, false).then((result) => {
            dispatch({
                type: actionTypes.SELECT_CHAT_FILTER_OPTIONS_LOADING,
                isLoading: false
            })

            const { data } = result;

            console.log("DATA",data)
            if (result.isSuccess && data.isSuccess) {
                var filterOptions = data.data;
                dispatch({
                    type: actionTypes.SELECT_CHAT_FILTER_OPTIONS_SUCCESS,
                    payload: filterOptions
                })
            } else {
                dispatch({
                    type: actionTypes.SELECT_CHAT_FILTER_OPTIONS_ERROR,
                    errorMessage: result.errorMessage,
                    hasError: true
                })
            }

        }).catch((error) => {
            dispatch({
                type: actionTypes.SELECT_CHAT_FILTER_OPTIONS_LOADING,
                isLoading: false
            })
            dispatch({
                type: actionTypes.SELECT_CHAT_FILTER_OPTIONS_ERROR,
                errorMessage: "Filter seçenekleri yüklenirken hata oluştu",
                hasError: true
            })
        });
    }
};

export function changeConversationActivityStatus(params, skipChatListRefresh = false) {

    return (dispatch, getState) => {

        dispatch({
            type: actionTypes.CHANGE_CONVERSATION_ACTIVITY_STATUS_LOADING,
            isLoading: true
        })

        console.log("PARAMS",params);
        return network.post("/Messages/changeCustomerActivityStatus", params, false).then((result) => {
            dispatch({
                type: actionTypes.CHANGE_CONVERSATION_ACTIVITY_STATUS_LOADING,
                isLoading: false
            })

            const { data } = result;
            if (result.isSuccess && data.isSuccess) {
                dispatch({
                    type: actionTypes.CHANGE_CONVERSATION_ACTIVITY_STATUS_SUCCESS,
                    customerNumber: params.customerNumber,
                    activityId: params.activityId,
                    activityName: params.activityName
                })
                
                // Only refresh chat list if skipChatListRefresh is false
                if (!skipChatListRefresh) {
                    dispatch(selectChatList({}));
                }
                
                return { success: true };
            } else {
                dispatch({
                    type: actionTypes.CHANGE_CONVERSATION_ACTIVITY_STATUS_ERROR,
                    errorMessage: result.errorMessage || data.errorMessage,
                    hasError: true
                })
                return { success: false, error: result.errorMessage || data.errorMessage };
            }

        }).catch((error) => {
            dispatch({
                type: actionTypes.CHANGE_CONVERSATION_ACTIVITY_STATUS_LOADING,
                isLoading: false
            })
            dispatch({
                type: actionTypes.CHANGE_CONVERSATION_ACTIVITY_STATUS_ERROR,
                errorMessage: "Aktivite durumu değiştirilirken hata oluştu",
                hasError: true
            })
            return { success: false, error: "Aktivite durumu değiştirilirken hata oluştu" };
        });
    }
};

export function updateChatItemStatus(customerNumber) {
    return (dispatch, getState) => {
        // HİÇBİR ŞEY YAPMA! Loading olmasın diye
        console.log("updateChatItemStatus çağrıldı ama hiçbir şey yapılmıyor:", customerNumber);
        // API çağrısı YOK, loading YOK!
    }
};